import "./AddDriverModal.scss"
import { FC, useRef, useState } from "react"
import { Button } from "@mui/material"
import { checkDriverEmailAsync } from "../../../redux/slices/driverSlice"
import { useAppDispatch } from "../../../redux/hooks"
import GenericModal from "../GenericAppModal/GenericModal.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import AppInput from "../../AppInput/AppInput.component"
import likeIcon from "../../../assets/images/like.png"
import {
  emailFormInitialValues,
  useValidationSchemas,
} from "../../../hooks/useIsValidationScehemes"

type AddDriverModalProps = {
  open: boolean
  handleClose: () => void
}

const AddDriverModal: FC<AddDriverModalProps> = ({ open, handleClose }) => {
  const {
    INPUT_EMAIL,
    ADD_A_DRIVER,
    ADD_A_DRIVER_MODAL_DESCRIPTIN1,
    ADD_A_DRIVER_MODAL_DESCRIPTIN2,
    EMAIL_ALREADY_EXISTS,
    ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_1,
    ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_2,
  } = useTranslationLabel()

  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const formSubmitted = useRef(false)
  const { emailSchema } = useValidationSchemas()

  const { formData, errors, handleChange, validateForm } = useFormValidation(
    emailFormInitialValues,
    emailSchema,
  )

  const handleAddDriverSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)

    formSubmitted.current = true
    if (!validateForm()) {
      setLoading(false)
      return
    }

    try {
      const email = formData.email
      const response = await dispatch(checkDriverEmailAsync(email)).unwrap()
      if (response.value === "true") {
        dispatch(
          showModal({
            activeModal: ModalTypes.SIMPLE_MODAL,
            data: {
              title: ADD_A_DRIVER,
              description: ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_1,
              description2: ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_2,
              image: likeIcon,
            },
          }),
        )
      } else if (response.value === "false") {
        dispatch(
          showModal({
            activeModal: ModalTypes.ADD_DRIVER_DETAILS_MODAL,
            data: { email },
          }),
        )
      }
    } catch (error) {
      //TODO LOW Add secondary modal
      alert(EMAIL_ALREADY_EXISTS)
    }
    setLoading(false)
  }

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={ADD_A_DRIVER}
      className="add-driver"
      loading={loading}
      description={ADD_A_DRIVER_MODAL_DESCRIPTIN1}
      description2={ADD_A_DRIVER_MODAL_DESCRIPTIN2}
    >
      <form onSubmit={handleAddDriverSubmit} className="form-container column">
        <AppInput
          label={INPUT_EMAIL}
          name="email"
          value={formData.email}
          type="email"
          className="email"
          error={errors.email}
          onChange={handleChange}
        />

        <Button type="submit" variant="contained" className="primary-btn">
          {ADD_A_DRIVER}
        </Button>
      </form>
    </GenericModal>
  )
}

export default AddDriverModal
